import { DataCard } from "components/common/DataCard";
import {
  CIRH_CHOICES_HEADING,
  CHOICES_TITLE,
  ONE_CHOICE_TITLE,
  CHOICES_NOTE,
  CIRH_CHOICE_TEXT,
  CIRH_CHOICES_TEXT1,
  CIRH_CHOICES_TEXT2,
  CIRH_CHOICES_TITLE,
} from "./RequestRepaymentHoliday.const";

interface CIRHChoicesExplainedProps {
  showSingleOption?: boolean;
}

export const CIRHChoicesExplained = ({
  showSingleOption = false,
}: CIRHChoicesExplainedProps) => {
  if (showSingleOption) {
    return (
      <DataCard>
        <div className="choices-explained">
          <div className="zb-heading4 card-sub-heading">
            {CIRH_CHOICES_HEADING}
          </div>
          <div className="selected-options-title">{CIRH_CHOICES_TITLE}</div>
          <div>
            <strong>{ONE_CHOICE_TITLE}</strong>
          </div>
          <ul>
            <li>
              <span>{CIRH_CHOICE_TEXT}</span>
            </li>
          </ul>
        </div>
      </DataCard>
    );
  }

  return (
    <DataCard>
      <div className="choices-explained">
        <div className="zb-heading4 card-sub-heading">
          {CIRH_CHOICES_HEADING}
        </div>
        <div className="selected-options-title">{CIRH_CHOICES_TITLE}</div>
        <div>
          <strong>{CHOICES_TITLE}</strong>
        </div>
        <ul>
          <li>
            <span>{CIRH_CHOICES_TEXT1}</span>
          </li>
          <li>
            <span>{CIRH_CHOICES_TEXT2}</span>
          </li>
        </ul>
        <div className="selected-options-note">
          <strong>{CHOICES_NOTE}</strong>
        </div>
      </div>
    </DataCard>
  );
};
